import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { change, reset } from 'redux-form';
import Dashboard from '../../Components/Dashboard';
import ReceivedMessages from '../Tables/Client/ReceivedMessages';
import Title from '../../Components/Layouts/Default/Header/Styled/Title';
import trans from '../../Translations/translation.service';
import { actions as allKeywordsActions } from '../../Redux/Api/AllKeywords';
import { actions as allShortCodesActions } from '../../Redux/Api/AllShortCodes';
import { actions as messagesShortCodeStatsActions } from '../../Redux/Api/MessagesShortCodeStats';
import { actions as navBarActions } from '../../Redux/Ducks/Navbar';
import {
  CLIENT_SHORT_CODES_STATS_FILTERS_INPUTS,
} from './config';
import { FILTERS_FORM as form } from '../../Components/Filters/config';
import {
  ALL_SELECT_OPTION_F,
  ALL_SELECT_OPTION_M,
  ALL_SELECT_OPTION_VALUE as ALL,
  API_DATE_FORMAT,
  API_DATE_FORMAT_FIRST,
} from '../../Constants';
import { getCarriersGeneralStats } from '../../Helpers';
import { PRIVATE_PATHS } from '../config';

class ClientShortCodesDashboard extends React.Component {
  state = {
    shortCode: ALL,
    filters: {},
  };

  initFilters = () => {
    const today = moment();
    this.props.reset(form);
    this.props.change(form, 'from_date', today.format(API_DATE_FORMAT_FIRST));
    this.props.change(form, 'to_date', today.format(API_DATE_FORMAT));
    this.props.change(form, 'keyword_id', ALL);
    this.props.change(form, 'short_code_id', ALL);
    this.props.change(form, 'carrier', ALL);
  };

  componentDidMount() {
    this.fetchAllKeywords();
    this.props.fetchAllShortCodes({}, { query: { client: true } });
    this.fetchMessagesShortCodeStats();
    this.initFilters();
    this.props.setOnSearch(this.handleSearch);
  }

  fetchAllKeywords = () => {
    const { shortCode } = this.state;

    if (shortCode === ALL) {
      this.props.fetchAllKeywords({}, { query: { client: true } });
    } else {
      this.props.fetchAllKeywords({}, { query: { client: true, short_code: shortCode } });
    }
  };

  fetchAllKeywordsFromShortCode = shortCode => {
    const { filters } = this.state;

    if (shortCode === ALL) {
      delete filters.short_code;
    } else {
      filters.short_code =  shortCode;
    }

    delete filters.keyword;
    this.props.change(form, 'keyword_id', null);

    this.setState({ filters, shortCode }, () => {
      this.fetchAllKeywords();
      this.fetchMessagesShortCodeStats();
    });
  };

  fetchMessagesShortCodeStats = () => {
    const { filters } = this.state;

    this.props.fetchMessagesShortCodeStats({}, { query: { client: true, ...filters } });
  };

  fetchMessagesShortCodeStatsFromCarrier = carrier => {
    const { filters } = this.state;

    if (carrier === ALL) {
      delete filters.carrier;
    } else {
      filters.carrier =  carrier;
    }

    this.setState({ filters }, () => {
      this.fetchMessagesShortCodeStats();
    });
  };

  fetchMessagesShortCodeStatsFromDateFrom = date => {
    const { filters } = this.state;

    const momentDate = moment(date, API_DATE_FORMAT);

    if (momentDate._isValid) {
      filters.from =  date;
    } else {
      delete filters.from;
    }

    this.setState({ filters }, () => {
      this.fetchMessagesShortCodeStats();
    });
  };

  fetchMessagesShortCodeStatsFromDateTo = date => {
    const { filters } = this.state;

    const momentDate = moment(date, API_DATE_FORMAT);

    if (momentDate._isValid) {
      filters.to =  date;
    } else {
      delete filters.to;
    }

    this.setState({ filters }, () => {
      this.fetchMessagesShortCodeStats();
    });
  };

  fetchMessagesShortCodeStatsFromKeyword = keyword => {
    const { filters } = this.state;

    if (keyword === ALL) {
      delete filters.keyword;
    } else {
      filters.keyword =  keyword;
    }

    this.setState({ filters }, () => {
      this.fetchMessagesShortCodeStats();
    });
  };

  handleSearch = (search)  => {
    const { filters } = this.state;

    filters.search = search;

    this.setState({ filters }, () => {
      this.fetchMessagesShortCodeStats();
    });
  };

  loading = () => {
    const {
      isFetchingKeywords,
      isFetchingShortCodes,
    } = this.props;
    return isFetchingKeywords
      || isFetchingShortCodes;
  };

  parseKeywords = () => {
    const keywords = this.props.keywords.map(({ id: value, word: text }) => ({
      text, value,
    }));

    keywords.unshift(ALL_SELECT_OPTION_F);

    return keywords;
  };

  parseShortCodes = () => {
    const shortCodes = this.props.shortCodes.map(({ id: value, code: text }) => ({
      text, value,
    }));

    shortCodes.unshift(ALL_SELECT_OPTION_M);

    return shortCodes;
  };

  render() {
    const messagesPath = PRIVATE_PATHS.clientReceivedMessages.path;
    const repliesPath = PRIVATE_PATHS.clientSentReplies.path;
    const { isFetching, stats } = this.props;
    const [dailyStats, hourlyStats, carrierStats, generalStats] = stats;
    const keywords = this.parseKeywords();
    const shortCodes = this.parseShortCodes();
    const carrierGeneralStats = getCarriersGeneralStats(carrierStats, messagesPath);

    return (
      <>
        <Dashboard
          filtersProps={{
            afterChange: {
              from_date: this.fetchMessagesShortCodeStatsFromDateFrom,
              to_date: this.fetchMessagesShortCodeStatsFromDateTo,
              short_code_id: this.fetchAllKeywordsFromShortCode,
              keyword_id: this.fetchMessagesShortCodeStatsFromKeyword,
              carrier: this.fetchMessagesShortCodeStatsFromCarrier,
            },
            data: {
              keyword_id: keywords,
              short_code_id: shortCodes,
            },
            inputs: CLIENT_SHORT_CODES_STATS_FILTERS_INPUTS,
            loading: this.loading(),
          }}
          dailyStats={dailyStats}
          hourlyStats={hourlyStats}
          carrierStats={carrierStats}
          generalStats={generalStats && [
            {
              link: messagesPath,
              name: trans('default.stats.messages.received_messages'),
              value: generalStats.received_messages.received_messages,
              size: {
                xs: 12,
                lg: 3,
              },
            },
            {
              link: repliesPath,
              name: trans('default.stats.messages.sent_replies'),
              value: generalStats.sent_replies.sent_replies,
              size: {
                xs: 12,
                lg: 3,
              },
            },
            ...carrierGeneralStats,
          ]}
          loading={isFetching}
        />
        <Title>{trans('default.titles.lastReceivedMessages')}</Title>
        <ReceivedMessages onDashboard order="created" showFilters={false} showPagination={false} sort="DESC" />
      </>
    );
  }
}

const mapStateToProps = ({
  allKeywords: {
    isFetching: isFetchingKeywords,
    items: keywords,
  },
  allShortCodes: {
    isFetching: isFetchingShortCodes,
    items: shortCodes,
  },
  messagesShortCodeStats: {
    isFetching,
    items,
  },
}) => ({
  isFetching,
  isFetchingKeywords,
  isFetchingShortCodes,
  keywords: keywords[1] ? keywords[1] : [],
  shortCodes: shortCodes[1] ? shortCodes[1] : [],
  stats: items,
});

export default connect(
  mapStateToProps,
  {
    change,
    reset,
    ...allKeywordsActions,
    ...allShortCodesActions,
    ...messagesShortCodeStatsActions,
    ...navBarActions,
  }
)(ClientShortCodesDashboard);
